import { APIClient } from '@frontend/api-utils';
import { PostActuator } from '@frontend/device/types';

export class DeviceActuatorClient extends APIClient {
    public static readonly endpoint = '/device-api/v1';

    public static async postDeviceActuator(accountId: string, iotId: string, deviceId: string, body: PostActuator): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/actuators`, body);
        return this.handleVoidResponse(response);
    }

    public static async openDevice(accountId: string, iotId: string, deviceId: string): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/open`);
        return await this.handleVoidResponse(response);
    }

    public static async queryDevice(accountId: string, iotId: string, deviceId: string): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/query`);
        return await this.handleVoidResponse(response);
    }
}
